import {
  getDownloadCapitalActivitiesCsvSampleMockHandler,
  getIngestCapitalActivityWithCsvMockHandler,
  getValidateCapitalActivityWithCsvMockHandler,
} from "@vega-api/generated/capital-activity-ingestion-v1/capital-activity-ingestion-v1.msw";
import {
  getDownloadFundsCsvSampleMockHandler,
  getIngestFundWithCsvMockHandler,
  getValidateFundWithCsvMockHandler,
} from "@vega-api/generated/fund-ingestion-v1/fund-ingestion-v1.msw";
import {
  getDownloadInvestmentsCsvSampleMockHandler,
  getIngestInvestmentWithCsvMockHandler,
  getValidateInvestmentWithCsvMockHandler,
} from "@vega-api/generated/investment-ingestion-v1/investment-ingestion-v1.msw";
import {
  getDownloadInvestorDocumentsCsvSampleMockHandler,
  getIngestInvestorDocumentWithCsvMockHandler,
  getValidateInvestorDocumentWithCsvMockHandler,
} from "@vega-api/generated/investor-document-ingestion-v1/investor-document-ingestion-v1.msw";
import {
  getDownloadLegalEntitiesCsvSampleMockHandler,
  getIngestLegalEntitiesWithCsvMockHandler,
  getValidateLegalEntitiesWithCsvMockHandler,
} from "@vega-api/generated/legal-entity-ingestion-v1/legal-entity-ingestion-v1.msw";
import {
  getDownloadLimitedPartnersCsvSampleMockHandler,
  getIngestLimitedPartnerWithCsvMockHandler,
  getValidateLimitedPartnerWithCsvMockHandler,
} from "@vega-api/generated/limited-partner-ingestion-v1/limited-partner-ingestion-v1.msw";
import {
  getDownloadInvestmentMetricsCsvSampleMockHandler,
  getIngestInvestmentMetricWithCsvMockHandler,
  getValidateInvestmentMetricWithCsvMockHandler,
} from "@vega-api/generated/metric-ingestion-v1/metric-ingestion-v1.msw";
import {
  getDownloadOpportunitiesCsvSampleMockHandler,
  getIngestFundOpportunityWithCsvMockHandler,
  getValidateFundOpportunityWithCsvMockHandler,
} from "@vega-api/generated/opportunity-ingestion-v1/opportunity-ingestion-v1.msw";
import {
  getDownloadUsersCsvSampleMockHandler,
  getIngestUserWithCsvMockHandler,
  getValidateUserWithCsvMockHandler,
} from "@vega-api/generated/user-ingestion-v1/user-ingestion-v1.msw";
import {
  getDownloadUserRolesCsvSampleMockHandler,
  getIngestUserRoleWithCsvMockHandler,
  getValidateUserRoleWithCsvMockHandler,
} from "@vega-api/generated/user-role-ingestion-v1/user-role-ingestion-v1.msw";
import {
  getDownloadWireInstructionsCsvSampleMockHandler,
  getIngestWireInstructionWithCsvMockHandler,
  getValidateWireInstructionWithCsvMockHandler,
} from "@vega-api/generated/wire-instruction-ingestion-v1/wire-instruction-ingestion-v1.msw";

/**
 * Handlers for ingestion upload routes (validate, ingest, download template)
 * These handlers are used in F2F tests for testing the ingestion flow
 */
export const ingestionHandlers = [
  // Legal Entities (Investing Entities)
  getDownloadLegalEntitiesCsvSampleMockHandler(),
  getValidateLegalEntitiesWithCsvMockHandler(),
  getIngestLegalEntitiesWithCsvMockHandler(),

  // Limited Partners (Organizations)
  getDownloadLimitedPartnersCsvSampleMockHandler(),
  getValidateLimitedPartnerWithCsvMockHandler(),
  getIngestLimitedPartnerWithCsvMockHandler(),

  // Users
  getDownloadUsersCsvSampleMockHandler(),
  getValidateUserWithCsvMockHandler(),
  getIngestUserWithCsvMockHandler(),

  // User Roles
  getDownloadUserRolesCsvSampleMockHandler(),
  getValidateUserRoleWithCsvMockHandler(),
  getIngestUserRoleWithCsvMockHandler(),

  // Investments
  getDownloadInvestmentsCsvSampleMockHandler(),
  getValidateInvestmentWithCsvMockHandler(),
  getIngestInvestmentWithCsvMockHandler(),

  // Capital Activities
  getDownloadCapitalActivitiesCsvSampleMockHandler(),
  getValidateCapitalActivityWithCsvMockHandler(),
  getIngestCapitalActivityWithCsvMockHandler(),

  // Investor Documents
  getDownloadInvestorDocumentsCsvSampleMockHandler(),
  getValidateInvestorDocumentWithCsvMockHandler(),
  getIngestInvestorDocumentWithCsvMockHandler(),

  // Wire Instructions
  getDownloadWireInstructionsCsvSampleMockHandler(),
  getValidateWireInstructionWithCsvMockHandler(),
  getIngestWireInstructionWithCsvMockHandler(),

  // Funds
  getDownloadFundsCsvSampleMockHandler(),
  getValidateFundWithCsvMockHandler(),
  getIngestFundWithCsvMockHandler(),

  // Opportunities
  getDownloadOpportunitiesCsvSampleMockHandler(),
  getValidateFundOpportunityWithCsvMockHandler(),
  getIngestFundOpportunityWithCsvMockHandler(),

  // Investment Metrics
  getDownloadInvestmentMetricsCsvSampleMockHandler(),
  getValidateInvestmentMetricWithCsvMockHandler(),
  getIngestInvestmentMetricWithCsvMockHandler(),
];
